import { PRIORITY } from '../../utils/Constants';
import ValidationService from '../../services/ValidationService';
// Form interaction management
class FormHandler {
    form;
    constructor(formReference) {
        this.form = formReference;
    }
    handlePrioritySelect(e) {
        const target = e.target;
        if (!(target instanceof Element))
            return;
        const priorityInput = document.querySelector('#priority');
        if (!(priorityInput instanceof HTMLInputElement))
            return;
        const listItems = document.querySelectorAll('.priority-picker li');
        listItems.forEach((item) => item.classList.remove('active'));
        const selectedListItem = target.closest('li');
        if (!selectedListItem)
            return;
        selectedListItem.classList.add('active');
        if (selectedListItem.id === 'low-priority')
            priorityInput.value = PRIORITY.LOW;
        if (selectedListItem.id === 'medium-priority')
            priorityInput.value = PRIORITY.MEDIUM;
        if (selectedListItem.id === 'high-priority')
            priorityInput.value = PRIORITY.HIGH;
    }
    handleListSelect(e) {
        const target = e.target;
        if (!(target instanceof Element))
            return;
        if (target.matches('h5'))
            return;
        const listInput = document.querySelector('#list');
        if (!(listInput instanceof HTMLInputElement))
            return;
        listInput.value = target.textContent;
    }
    handleListAdd(e) {
        e.preventDefault();
        const target = e.target;
        if (!(target instanceof HTMLFormElement))
            return;
        const formData = this.saveFormData(target);
        const listTitle = Object.values(formData).join('');
        const isValidated = ValidationService.validateInput(listTitle);
        if (isValidated)
            return listTitle;
    }
    saveFormData(form) {
        const formData = new FormData(form);
        const values = Object.fromEntries(formData.entries());
        return {
            'task-title': values['task-title'],
            'task-description': values['task-description'],
            'task-schedule': values['task-schedule'],
            'task-deadline': values['task-deadline'],
            priority: values['priority'],
            list: values['list'],
        };
    }
}
export default FormHandler;
